import { Zap, CalendarClock } from "lucide-react";
import { useBookCall } from "@/pages/Landing";

export default function Hero() {
  const book = useBookCall();
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1760813360432-9b5d79eb9679"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05050A]/60 via-[#05050A]/80 to-[#05050A]" />
      </div>
      <div className="absolute inset-0 -z-10 grid-bg opacity-30" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="max-w-4xl">
          <div className="overline mb-6 flex items-center gap-3 animate-fade-up" style={{ animationDelay: "0.1s", opacity: 0 }}>
            <Zap size={14} className="text-neon-cyan" />
            <span>System: ONE BRAND // SEVEN VENTURES</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading font-black text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tighter animate-fade-up"
            style={{ animationDelay: "0.2s", opacity: 0 }}
          >
            Seven ventures.<br />
            <span className="text-neon-cyan neon-text-cyan">One playbook</span><br />
            for wealth.
          </h1>

          <p
            className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl font-body animate-fade-up"
            style={{ animationDelay: "0.4s", opacity: 0 }}
          >
            <span className="text-white font-semibold">Techsavvypreneurs</span> is where serious entrepreneurs come to diversify income — across websites, in various industries like real estate, retail, credit, markets, fitness, and marketing. <span className="text-white">Tested systems. Honest guidance. Real results.</span>
          </p>

          <div
            className="mt-10 flex flex-wrap items-center gap-4 animate-fade-up"
            style={{ animationDelay: "0.55s", opacity: 0 }}
          >
            <button onClick={() => book.open()} data-testid="hero-cta-primary" className="btn-primary">
              Reserve 15-min Call <CalendarClock size={16} />
            </button>
            <a href="#ventures" data-testid="hero-cta-secondary" className="btn-ghost">
              Explore Ventures
            </a>
          </div>

          <div className="mt-16 flex flex-wrap gap-x-10 gap-y-4 text-xs font-mono uppercase tracking-wider text-white/40 animate-fade-up" style={{ animationDelay: "0.7s", opacity: 0 }}>
            <span>// Years In The Field</span>
            <span>// Seven Active Ventures</span>
            <span>// US + Remote</span>
          </div>
        </div>
      </div>

      {/* Decorative lines */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-cyan/40 to-transparent" />
    </section>
  );
}
